import { Injectable } from "@angular/core";
import { MCPersonalVehicleImportService } from "@maslul/common-services";

@Injectable({
    providedIn: 'root'
})
export class PersonalVehicleImportService extends MCPersonalVehicleImportService {
}
